import { Injectable, NgZone } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import {
  AngularFirestore,
  AngularFirestoreDocument,
} from "@angular/fire/compat/firestore";
import { Router } from "@angular/router";
import { error } from "console";
import * as auth from "firebase/auth";
import firebase from "firebase/compat";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class GoogleAuthService {
  userData: any; // Save logged in user data

  constructor(
    public afs: AngularFirestore, // Inject Firestore service
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    public router: Router,
    public ngZone: NgZone // NgZone service to remove outside scope warning
  ) {
  }

  SignIn(email: string, password: string): Promise<any> {
    return this.afAuth.signInWithEmailAndPassword(email, password);
  }

  // Sign up with email/password
  SignUp(email: string, password: string) {
    return this.afAuth
      .createUserWithEmailAndPassword(email, password)
      .then((result) => {
        /* Call the SendVerificaitonMail() function when new user sign 
        up and returns promise */
        this.SendVerificationMail();
        // this.SetUserData(result.user);
      })
      .catch((error) => {
        window.alert(error.message);
      });
  }

  // Send email verfificaiton when new user sign up
  SendVerificationMail() {
    return this.afAuth.currentUser
      .then((u: any) => u.sendEmailVerification())
      .then(() => {
        this.router.navigate(["verify-email-address"]);
      });
  }

  ForgotPassword(passwordResetEmail: string):Promise<any> {
    return this.afAuth.sendPasswordResetEmail(passwordResetEmail);
  }


  // Returns true when user is looged in and email is verified
  get isLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem("user")!);
    return user !== null && user.emailVerified !== false ? true : false;
  }

  GoogleAuth() {
    const provider = new auth.GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: "select_account consent",
      login_hint: ""
    });
  
    return this.AuthLogin(provider)
      .then((result: any) => {
        this.listenForSignOut();
     
        // Handle the successful login result
        return result;
      })
      .catch((error: any) => {
        // Handle the error
        return error;
      });
  }
  
  
  // Auth logic to run auth providers
  AuthLogin(provider: any) {
    return this.afAuth
      .signInWithPopup(provider)
      .then((result: any) => {
        return result;
      })
      .catch((error: any) => {
        throw error;
      });
  }

  listenForSignOut() {
    this.afAuth.onAuthStateChanged((user) => {
      if (!user) {
        // User is signed out, perform the necessary actions
        // For example: redirect to a sign-out page or trigger the sign-out functionality
        this.signOut();
      }
    });
  }


  // Sign out
  signOut() {
    return this.afAuth.signOut().then(() => {
      // localStorage.removeItem('user');
      this.router.navigate(["login"]);
    });
  }

  verifyPasswordResetCode(actionCode):Promise<any> {
    return this.afAuth.verifyPasswordResetCode(actionCode)
  }

  confirmPasswordReset(actionCode, newPassword):Promise<any> {
    return this.afAuth.confirmPasswordReset(actionCode, newPassword)

  }

  handleVerifyEmail(actionCode) {

    return this.afAuth.applyActionCode(actionCode)
  }
}
